import { create } from "zustand";

interface ClaimFormStore {
  tenPercentBankDetails: {
    bankName: string;
    accountName: string;
    branchCode: string;
    accountType: string;
    accountTypeId: string;
    accountNumber: string;
    branchName: string;
    claimAmount: string;
  };
  setTenPercentBankDetails: (
    data: Partial<ClaimFormStore["tenPercentBankDetails"]>
  ) => void;
  resetTenPercentBankDetails: () => void;
}
export const useTenPercentBankDetailsStore = create<ClaimFormStore>((set) => ({
  tenPercentBankDetails: {
    bankName: "",
    accountName: "",
    branchCode: "",
    accountType: "",
    accountTypeId: "",
    accountNumber: "",
    branchName: "",
    claimAmount: "",
  },
  setTenPercentBankDetails: (data) =>
    set((state) => ({
      tenPercentBankDetails: {
        ...state.tenPercentBankDetails,
        ...data,
      },
    })),
  resetTenPercentBankDetails: () =>
    set(() => ({
      tenPercentBankDetails: {
        bankName: "",
        accountName: "",
        branchCode: "",
        accountType: "",
        accountTypeId: "",
        accountNumber: "",
        branchName: "",
        claimAmount: "",
      },
    })),
}));
